import React, { Component } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import userService from '../../api/userService';

export default class ConfirmDisableUser extends Component {
    constructor(props) {
        super(props);

        this.disableUser = this.disableUser.bind(this);
    }

    disableUser() {
        const { id } = this.props.user;
        userService.statusUser(id, true)
        .then(() => {
            this.props.onClose();
        });
    }

    render() {
        const { showConfirm, onClose, user } = this.props;
        if (user) {
            return (
                <Dialog
                    open={showConfirm}
                    onClose={onClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Enable this account?</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            You are activating the {user.fullName} account. He can connect to BackOffice if you continue.
                            Do you want to proceed?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onClose} color="primary">No, go back</Button>
                        <Button onClick={this.disableUser} color="primary" autoFocus>Yes</Button>
                    </DialogActions>
                </Dialog>
            );
        } else {
            return null;
        }
    }
}